import { Card, OneColumnWrapper, StepContainer, TopContentContainer } from './styles';
import ProgressBar from 'components/ProgressBar';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { isAfcOktaUser, isAffiliatePartner, isFastPathSignUp } from 'partials/sign_up/helpers';
import AffiliatePartnerBanner from './AffiliatePartnerBanner';

const SignUpOneColumn = ({ CardContent, TopContent, step, hideProgressBar = false }) => {
	const { t } = useTranslation(['signup']);
	const router = useRouter();
	const isOneSingleStepSignUp =
		isAfcOktaUser(router.query) || isFastPathSignUp(router.query) || isAffiliatePartner(router.query);
	const showProgressBar = step <= 3 && !isOneSingleStepSignUp && !hideProgressBar;
	const isAffiliatePartnerSignup = isAffiliatePartner(router.query);
	const progressSteps = [
		t('signup:progressBarNames.step0'),
		t('signup:progressBarNames.step1'),
		t('signup:progressBarNames.step2'),
	];

	return (
		<OneColumnWrapper>
			{showProgressBar && (
				<StepContainer hasTopContent={Boolean(TopContent)}>
					<ProgressBar selectedStep={step + 1} steps={progressSteps} />
				</StepContainer>
			)}

			{TopContent && <TopContentContainer>{TopContent}</TopContentContainer>}

			{isAffiliatePartnerSignup && <AffiliatePartnerBanner />}

			<Card>{CardContent}</Card>
		</OneColumnWrapper>
	);
};

export default SignUpOneColumn;
